export const showFlashMessageImp = (message: string, type: 'success' | 'error' | 'info' | 'warning') => {
    let existingFlashMessage = document.getElementById('sui-flash-message');
    if (!existingFlashMessage) {
        const div = document.createElement('div');
        div.id = 'sui-flash-message';
        existingFlashMessage = div
    }
    existingFlashMessage.className = `sui-flash-message show ${type}`;
    existingFlashMessage.innerHTML = `<h4>${message}</h4>`;
    document.body.appendChild(existingFlashMessage);
    setTimeout(() => {
        existingFlashMessage.className = `sui-flash-message hide ${type}`;
    }, 3000)
}